import Swiper from 'swiper/dist/js/swiper';
import 'jquery';
import onDocumentReady from '../utilities/onDocumentReady';

onDocumentReady(() => new Swiper('.index-catalog-slider .swiper-container', {
    speed: 600,
    autoHeight: true,
    breakpoints: {
        767: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
    },
}));
